class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('#email_signup');
        this.childAge = this.querySelector('[name="child_age"]');
        this.ageSelect = this.querySelectorAll('[name="age_select[]"]');
        this.shoppingFor = this.querySelectorAll('[name="shopping_for"]');
        this.dueDateBox = this.querySelector('#dueDateBox');
        this.childAgeBox = this.querySelector('#childAgeBox');
        
        this.newsletterPopUpShow();
        this.newsletterDate();
        this.klaviyoSubscribeForm();
    }

    newsletterDate (){

        const localeEn = {
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today',
            clear: 'Clear',
            dateFormat: 'MM/dd/yyyy',
            timeFormat: 'hh:mm aa',
            firstDay: 0
        }
        // Create a date 1 year in the future
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var endDate = new Date(year + 1, month, day);
    
        new AirDatepicker('#dueDate', {
            locale: localeEn,
            minDate: new Date(),
            maxDate: endDate,
          })
    }

    klaviyoSubscribeForm(){

        let form = this.form;
        let dueDateBox = this.dueDateBox;
        let childAgeBox = this.childAgeBox;
        let childAge = this.childAge;
        let shoppingFor = this.shoppingFor;
        let ageSelect = this.ageSelect;



        KlaviyoSubscribe.attachToForms('#email_signup', {
            hide_form_on_success: true,
            success: function (form) {
                form.hide();
                document.querySelector('.modal__heading').style.display = "none";
                document.querySelector('.modal__subtext').style.display = "none";
                console.log('SMS Bump: ', document.querySelector('#SMSBump'));
                document.querySelector('#SMSBump').classList.add('is--visible');
            },
            // success_message: window.theme.newsletter.success,
            extra_properties: {
                source: '$embed',
                method_type: "Klaviyo Form",
                method_id: 'embed',
                consent_version: 'Embed default text',
            }
        });

        var prev = null;
        for (var i = 0; i < shoppingFor.length; i++) {
            shoppingFor[i].addEventListener('change', function() {
                if (this !== prev) {
                    prev = this;
                }
                console.log(this.value)
                let val = this.value
                if( val == 'parent' ){
                    dueDateBox.style.display = 'none';
                    childAgeBox.style.display = 'block';
                }else if( val == 'myself' ){
                    dueDateBox.style.display = 'block';
                    childAgeBox.style.display = 'none';
                }else{
                    dueDateBox.style.display = 'none';
                    childAgeBox.style.display = 'none';
                }
            });
        }
        
        for (var i = 0; i < ageSelect.length; i++) {
            ageSelect[i].addEventListener('change', function() {
                // have an empty array to store the values in
                var values = [];
                
                for (var i = 0; i < ageSelect.length; i++) {
                    if(ageSelect[i].checked){
                        values.push(ageSelect[i].value);
                    }
                }
                childAge.value = values.toString();
            });
        }
        
    }

    newsletterPopUpShow(){

        if(document.cookie.match(/^(.*;)?\s*newsletter-popup\s*=\s*[^;]+(.*)?$/) === null || document.cookie.match(/^(.*;)?\s*newsletter-popup\s*=\s*[^;]+(.*)?$/) === undefined){
            setTimeout(function(){
                MicroModal.show('newsletterPopup', {
                    onShow: function () {
                        document.body.classList.add('no--scroll');
                    },
                    onClose: function(modal, element, event) {
                        event.preventDefault();
                        event.stopPropagation(); 
                        document.body.classList.remove('no--scroll');
                    }
                });

                const d = new Date();
                d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
                let expires = "expires="+d.toUTCString();
                document.cookie = 'newsletter-popup' + "=" + true + ";" + expires + ";path=/";
            
            }, window.theme.popup.delay);
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);
